import {
  Maybe,
  CalendarDateInput,
  Operation,
} from '../../../__generated__/globalTypes'

import {
  DetailedContactFragment,
  detailedContactFragmentString,
} from '../../fragments/__generated__/DetailedContactFragment'

import { calendarDateFragmentString } from '../../fragments/__generated__/CalendarDateFragment'

import { contactFragmentString } from '../../fragments/__generated__/ContactFragment'

import { relatedContactFragmentString } from '../../fragments/__generated__/RelatedContactFragment'

import { noteFragmentString } from '../../fragments/__generated__/NoteFragment'

import createNoteRawString from '../CreateNote.graphql'

const createNoteString = [
  createNoteRawString,
  detailedContactFragmentString,
  calendarDateFragmentString,
  contactFragmentString,
  relatedContactFragmentString,
  noteFragmentString,
].join('\n\n')

export type CreateNoteData = {
  createNote: {
    contact: DetailedContactFragment
  }
}

export type CreateNoteVariables = {
  id: string
  text: string
  date?: Maybe<CalendarDateInput>
}

export type CreateNote = Operation<CreateNoteData, CreateNoteVariables>

export const CreateNote = ({
  id,
  text,
  date,
}: CreateNoteVariables): CreateNote => ({
  query: createNoteString,
  variables: {
    id,
    text,
    date: date && CalendarDateInput(date),
  },
})
